import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data-service.service';

@Component({
  selector: 'top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class TopBarComponent implements OnInit {
  public displayMobileMenu = false;

  constructor(public ds: DataService) { }

  ngOnInit(): void {
    this.ds.setMobile();
  }

  public onResize(e: any) {
    this.ds.setMobile();
  }
}
